import { FC, Fragment } from 'react';

import { Levels } from '_core/utils/public-links/_types';

import * as S from '../styles';
import { ExploreDropdownToggle } from '../types';
import { AsideItem } from './aside-item';

export type ExploreAsideSectionProps = {
  title: string;
  exploreServicesByName?: Levels;
  exploreServicesByLocationMain?: Levels;
  exploreServicesByLocationOthers?: Levels;
  executeScroll: (param: string) => void;
  isOpenAsideDropdown?: ExploreDropdownToggle;
  openDropdown: (param: string) => void;
  openAsideDropdown: (param: string) => void;
  selectedId: string;
};

export const ExploreAsideSection: FC<ExploreAsideSectionProps> = (props) => {
  const {
    title,
    exploreServicesByName,
    exploreServicesByLocationMain,
    exploreServicesByLocationOthers,
    executeScroll,
    isOpenAsideDropdown,
    openDropdown,
    openAsideDropdown,
    selectedId,
  } = props;

  return (
    <Fragment>
      {isOpenAsideDropdown && (
        <S.Card
          className="overflow-auto shadow-2 rounded-lg px-2 py-4 sticky border border-secondary-300"
          data-testid="aside-card">
          <header className="pt-4 pb-2 px-2">
            <h4 className="bold">{title}</h4>
          </header>

          {exploreServicesByName &&
            Object.keys(exploreServicesByName)?.map((levelOne, key: number) => (
              <AsideItem
                levelKey={levelOne}
                selectedLevel={selectedId}
                openDropdown={openDropdown}
                levels={exploreServicesByName}
                openAsideDropdown={openAsideDropdown}
                isOpen={isOpenAsideDropdown[levelOne]}
                key={`$aside-btn-${levelOne}-${key}`}
                executeScroll={() => {
                  executeScroll(levelOne);
                }}
              />
            ))}

          {exploreServicesByLocationMain &&
            Object.keys(exploreServicesByLocationMain)?.map((levelOne, key) => (
              <AsideItem
                levelKey={levelOne}
                selectedLevel={selectedId}
                openDropdown={openDropdown}
                openAsideDropdown={openAsideDropdown}
                isOpen={isOpenAsideDropdown[levelOne]}
                levels={exploreServicesByLocationMain}
                key={`$aside-btn-${levelOne}-${key}`}
                executeScroll={() => {
                  executeScroll(levelOne);
                }}
              />
            ))}

          {exploreServicesByLocationOthers &&
            Object.keys(exploreServicesByLocationOthers)?.map((levelOne, key) => (
              <AsideItem
                levelKey={levelOne}
                selectedLevel={selectedId}
                openDropdown={openDropdown}
                openAsideDropdown={openAsideDropdown}
                isOpen={isOpenAsideDropdown[levelOne]}
                levels={exploreServicesByLocationOthers}
                key={`$aside-dropdown-${levelOne}-${key}`}
                executeScroll={() => {
                  executeScroll(levelOne);
                }}
              />
            ))}
        </S.Card>
      )}
    </Fragment>
  );
};
